export async function getFilesAsync(dataTransfer: DataTransfer): Promise<File[]> {
  const entries: FileSystemEntry[] = [];

  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < dataTransfer.items.length; i++) {
    const entry = dataTransfer.items[i].webkitGetAsEntry(); //Might be renamed to GetAsEntry() in 2020
    if (entry) {
      entries.push(entry);
    }
  }

  const files: File[] = [];
  for (const entry of entries) {
    files.push(...(await getFileTree(entry)));
  }

  return files;
}

async function getFileTree(item: FileSystemEntry): Promise<File[]> {
  return new Promise<File[]>((resolve) => {
    const files: File[] = [];
    if (item.isFile) {
      (item as FileSystemFileEntry).file(function (file) {
        files.push(file);
        resolve(files);
      });
    } else if (item.isDirectory) {
      const dirReader = (item as FileSystemDirectoryEntry).createReader();
      dirReader.readEntries(async function (entries: FileSystemEntry[]) {
        for (const entry of entries) {
          files.push(...(await getFileTree(entry)));
        }
        resolve(files);
      });
    }
  });
}
